import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationTriangleOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="M7.3 5.16v5.2h1.4v-5.2z" fill="currentColor" />
                    <path d="M8.933 12.093a.933.933 0 1 0-1.866 0 .933.933 0 0 0 1.866 0" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m1.23 11.441 4.445-8.12C6.705 1.44 7.22.5 8 .5c.78 0 1.295.94 2.325 2.82l4.446 8.121c.989 1.807 1.484 2.711 1.098 3.385s-1.399.674-3.423.674H3.554c-2.024 0-3.037 0-3.423-.674s.109-1.578 1.098-3.385m1.227.673 4.446-8.122C7.41 3.067 7.732 2.486 8 2.114c.268.372.59.953 1.097 1.878l4.446 8.122c.513.938.821 1.507.977 1.924-.424.058-1.048.062-2.074.062H3.554c-1.026 0-1.65-.004-2.074-.062.156-.417.464-.986.977-1.924"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ExclamationTriangleOutlinedSize16Glyph.displayName = 'ExclamationTriangleOutlinedSize16Glyph';
